import React, { useState } from "react";
import { Button, Form } from "antd";

import Craft from "components/craft";
import Localize from "components/service/localize";
import CollectGraphicsFields from "../fields";
import {
    getCollectGraphicsInitialValues,
    buildCollectGraphicsFilterState,
    getCollectGraphicsActiveFiltersCount
} from "../helpers/collect-graphics-filter-config";

const CollectGraphicsFilterForm = ({ filter, callback }) => {
    const [form] = Form.useForm();
    const { data, set, reset } = filter;
    const initialValues = getCollectGraphicsInitialValues(data);
    const [changedFieldsCount, setChangedFieldsCount] = useState(data.activeFilters);

    return (
        <Form
            key="collect-graphics-filter-form"
            form={form}
            layout="vertical"
            className="collect-graphics-filter-form"
            onFinish={(values) => {
                set(buildCollectGraphicsFilterState(values, data));
                callback();
            }}
            onValuesChange={(_, allValues) => {
                setChangedFieldsCount(getCollectGraphicsActiveFiltersCount(allValues));
            }}
        >
            <Form.Item
                name="block"
                label={<Localize>GLOBAL.Card_Hero_Block</Localize>}
                className="dark"
                initialValue={initialValues.block}
            >
                <CollectGraphicsFields.BlockSelect allowClear />
            </Form.Item>
            <Form.Item
                name="craftStatus"
                label={<Localize>FORMS.Input_Label_CraftStatus</Localize>}
                className="dark"
                initialValue={initialValues.craftStatus}
            >
                <Craft.Fields.StatusSelect craftType="collect_graphics" />
            </Form.Item>
            <div className="form-actions">
                {!changedFieldsCount ? (
                    <Button
                        className="dark"
                        type="default"
                        onClick={callback}
                    >
                        <Localize wrap>GLOBAL.Button_Text_Cancel</Localize>
                    </Button>
                ) : (
                    <>
                        <Button
                            className="dark"
                            type="default"
                            onClick={() => {
                                reset();
                                callback();
                            }}
                        >
                            <Localize wrap>FORMS.Button_Text_ResetFilters</Localize>
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            <Localize wrap>FORMS.Button_Text_ApplyFilters</Localize>
                        </Button>
                    </>
                )}
            </div>
        </Form>
    );
};

export default CollectGraphicsFilterForm;
